import React from 'react';
import DeveloperDocs from '../views/DeveloperDocs';
import MerchantDocs from '../views/MerchantDocs';
import ClientDocs from '../views/ClientDocs';
import DriverDocs from '../views/DriverDocs';

/**
 * Componente que renderiza dinámicamente la vista según la pestaña activa
 */
export default function MainContent({ activeTab }) {
  return (
    <main className="main-container">
      {activeTab === 'desarrolladores' && <DeveloperDocs />}
      {activeTab === 'comercios' && <MerchantDocs />}
      {activeTab === 'clientes' && <ClientDocs />}
      {activeTab === 'repartidores' && <DriverDocs />}
    </main>
  );
}
